import browserStorageService from './BrowserStorageService';
import crApi from './CrApi';

class SecurityService {
    static token: string;
    static user;
    static accountUserId = null;
    static role = [];
    static accountPrivileges = [];
    private static userPromise = null;

    public _planChangeWhen = 'now';
    public _showEmailConfirmationPopup = false;

    public tokenType = 'webapp_token';

    constructor() {
        // get the website token from the query string. Note we can't use vue route as it's not initialized and this point
        if (window['URLSearchParams'] !== undefined) {
            const urlParams = new URLSearchParams(location.search);
            if (urlParams.has('websiteToken')) {
                browserStorageService.setItem('token', urlParams.get('websiteToken'));
            }
        }

        if (browserStorageService.getItem('token') && browserStorageService.getItem('token') != 'notoken') {
            this.setToken(browserStorageService.getItem('token'));
            if (browserStorageService.getItem('accountUserId') && browserStorageService.getItem('accountUserId') != null) {
                this.setAccountUserId(browserStorageService.getItem('accountUserId'));
            }
        }
    }

    public async signOut() {
        const eventManager = (await import('./AppEventManagerService')).default;
        const token = this.getToken();
        if (token) {
            try {
                //@ts-ignore
                eventManager.emit('auth.signout-pre', {});
                await crApi.requestV2('security/logout', {hash: token});
            } catch (e) {
                this.destroyToken();
                //@ts-ignore
                eventManager.emit('auth.signout-post', {});
            }
        }
        this.destroyToken();
        //@ts-ignore
        eventManager.emit('auth.signout-post', {});
    }

    public isAuthenticated() {
        return SecurityService.token ? true : false;
    }

    public getToken() {
        return SecurityService.token;
    }

    public setToken(token) {
        SecurityService.token = token;
        SecurityService.userPromise = null;
        browserStorageService.setItem('token', token);
    };

    public getAccountUserId() {
        return SecurityService.accountUserId;
    }

    public setAccountUserId(accountUserId) {
        SecurityService.accountUserId = accountUserId;
        browserStorageService.setItem('accountUserId', accountUserId);
    }

    public async getUser(cache = true) {
        try {
            if (!this.isAuthenticated()) {
                SecurityService.user = null;
                SecurityService.userPromise = Promise.resolve(null);
                return SecurityService.user;
            }
            if (!cache) {
                SecurityService.userPromise = null;
            }
            if (SecurityService.userPromise === null) {
                SecurityService.userPromise = new Promise(async (resolve, reject) => {
                    if (SecurityService.accountUserId === null) {
                        SecurityService.user = await crApi.requestV2('admin/retrieve', {website_token:SecurityService.token, add_properties: 1});
                        SecurityService.role = ['owner'];
                    } else {
                        let admin = await crApi.requestV2('admin/retrieve', {website_token: SecurityService.token, accountUserId: SecurityService.accountUserId, add_properties: 1});
                        if (admin['admin'] && admin['admin'][0]['accountUser'] != null) {
                            let accountUser = admin['admin'][0]['accountUser'];
                            admin['admin'][0]['username'] = accountUser['username'];
                            admin['admin'][0]['_id'] = accountUser['_id'];
                            admin['admin'][0]['_account'] = accountUser['_account'];
                            admin['admin'][0]['accountId'] = accountUser['accountId'];
                            admin['admin'][0]['role'] = accountUser['role'];
                            SecurityService.role = accountUser['role'];
                            SecurityService.accountPrivileges = admin['admin'][0]['accountPrivileges'];
                        }
                        SecurityService.user = admin;
                    }
                    resolve(SecurityService.user);
                });
            }
            return SecurityService.userPromise;
        } catch (err) {
            console.log(err);
        }
    }

    public async me() {
        const response = await this.getUser();
        if (!response || response['error']) {
            return null;
        } else {
            return response['admin'][0];
        }
    }

    public destroyToken() {
        SecurityService.token = null;
        browserStorageService.removeItem('token');
        browserStorageService.removeItem('userAuthToken');
        browserStorageService.removeItem('accountUserId');
        if (browserStorageService.getItem('role') === 'user') {
            browserStorageService.removeItem('role');
        }
        SecurityService.userPromise = null;
        SecurityService.accountUserId = null;
        SecurityService.role = [];
    };

    public setPlanChangeWhen(planChangeWhen:any){
        this._planChangeWhen = planChangeWhen;
    }

    public getPlanChangeWhen(){
        return this._planChangeWhen;
    }

    public setShowEmailConfirmationPopup(showEmailConfirmationPopup) {
        this._showEmailConfirmationPopup = showEmailConfirmationPopup;
    }

    public isOwner() {
        return SecurityService.role.indexOf("owner") !== -1;
    }

    public hasPrivilege(privilege) {
        let accountPrivileges = SecurityService.accountPrivileges;
        return accountPrivileges[privilege] || this.isOwner();
    }

    public async getAdminTimezone() {
        const adminDetail = await this.me();
        let adminPropertyParams = {
            adminId: adminDetail?.adminId,
            timezoneProperties: true,
            website_token: this.getToken()
        }
        const tzProperty = await crApi.requestV2('admin/retrieve_admin_property_value/', adminPropertyParams);
        return tzProperty?.propertyValue[0]?.value;
    }
}

export default new SecurityService();
